import {faEdit} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {Link} from "react-router-dom";

import {ERoles} from "@/services/models";
import session from "@/services/session";
import {EDeviceClasses} from "@toolbox/models";
import {EDocIdPrefixes, EDocIdPrefixesPartial} from "../../search/models";

import license from "@/services/license";
import Delete from "@shared/sop/DeleteSop";
import TasksPanel from "@toolbox/building-blocks/TasksPanel";
import {
    device2DeviceApi,
    device2ServerId,
} from "@toolbox/functions/device-check";
import T from "@translate/T";
import ExportButton from "../../search/task-buttons/ExportButton";

interface ISopTasksProps {
    project: number;
    id: number;

    deviceClass: EDeviceClasses;
    name: string;
    owner: string;

    renderExecute?: (messages: React.RefObject<HTMLDivElement>) => JSX.Element;
}

class SopTasks extends React.PureComponent<ISopTasksProps> {
    private readonly messages = React.createRef<HTMLDivElement>();

    private get serverId() {
        return device2ServerId(this.props.deviceClass);
    }

    public render() {
        return (
            <React.Fragment>
                <TasksPanel>
                    {this.renderEdit()}
                    {this.renderExport()}
                    {this.renderExecute()}
                    {this.renderDelete()}
                </TasksPanel>

                <div ref={this.messages} />
            </React.Fragment>
        );
    }

    private renderEdit() {
        const {deviceClass, project, id} = this.props;

        if (
            !session.hasRole(ERoles.Editor, project) ||
            !license.getDeviceLicenses()[device2DeviceApi(deviceClass)]
        ) {
            return null;
        }

        return (
            <Link
                id="sop-edit-link"
                className="mr-1"
                to={`/project/${project}/${this.serverId}/wizard/${id}`}
            >
                <button type="button" className="btn btn-primary">
                    <FontAwesomeIcon
                        icon={faEdit}
                        fixedWidth={true}
                        className="mr-1"
                    />
                    <T>Edit</T>
                </button>
            </Link>
        );
    }

    private renderExport() {
        const {id, name, project} = this.props;
        const prefix = (this.serverId.substring(0, 4) +
            EDocIdPrefixesPartial.Sops) as
            | EDocIdPrefixes.CentSops
            | EDocIdPrefixes.FracSops
            | EDocIdPrefixes.SpocSops;

        return (
            <ExportButton
                idSuffix="sop"
                className="mr-1"
                name={name}
                project={project}
                selection={[{id: id.toString(), prefix}]}
            />
        );
    }

    private renderExecute() {
        const {project, renderExecute} = this.props;
        if (!session.hasRole(ERoles.Recorder, project)) {
            return null;
        }

        if (renderExecute) {
            return renderExecute(this.messages);
        }

        return null;
    }

    private renderDelete() {
        const {id, owner, project} = this.props;
        if (
            !session.hasRole(ERoles.Manager, project) &&
            !(session.hasRole(ERoles.Editor, project) && owner === session.user)
        ) {
            return null;
        }

        return (
            <Delete
                id={id}
                project={project}
                owner={owner}
                serverId={this.serverId}
                messages={this.messages}
            />
        );
    }
}

export default SopTasks;
